import {
  InputPreprocessors,
  PaymentAttribute,
  PreprocessorParam,
} from '@cashier/cashier-model';

import { PliromyService } from '../pliromy';

export const PreProcessorAttributeFilter = {
  filter: (
    attributes: PaymentAttribute[],
    preprocessor: PreprocessorParam | null,
  ): PaymentAttribute[] => {
    if (!preprocessor) {
      return attributes;
    }

    switch (preprocessor.type) {
      case InputPreprocessors.PLIROMY_TOKENIZER:
        return PliromyService.filterAttributes(attributes);

      default:
        return attributes;
    }
  },
};
